import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { LabService } from 'src/app/_service/lab.service';
import { UserService } from 'src/app/_service/user.service';
declare var $: any;

@Component({
  selector: 'app-move-surgery-lead',
  templateUrl: './move-surgery-lead.component.html',
  styleUrls: ['./move-surgery-lead.component.css']
})
export class MoveSurgeryLeadComponent implements OnInit {

  dialogData: any; moveLeadForm: FormGroup; loading: boolean = false; submitted: boolean = false; dataLoaded: boolean = false; 
  treatments = []; treatments_copy = []; bds = []; bds_copy = [];

  constructor(public dialogRef: MatDialogRef<MoveSurgeryLeadComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, private dialog: MatDialog,
    private router: Router, private sharedapi: SharedService, private leadapi: LeadsService, private formBuilder: FormBuilder, private labapi: LabService,private userapi:UserService) {
    this.dialogData = data;
    // this.dataLoaded = true;

    this.moveLeadForm = this.formBuilder.group({
      'treatment_id': [null, Validators.required],
      'user_id': [null, Validators.required],
      'name': [null, Validators.required],
      'mobile': [null, Validators.required],
      'city_id': [null, Validators.required],
      'circle_id': [null, Validators.required],
      'description': [null],
      'gender': [null],
      'lead_source': ['52']
    });
  }

  ngOnInit(): void {
    this.getLabLeadDetails();
    this.getTreatment();
    this.getTlsCms();

  }

  get f() { return this.moveLeadForm.controls; }


  CloseModal(): void {
    this.dialogRef.close();
  }

  setSearchValue(type) {
    if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    } else if (type == 'lead_owner') {
      $("#ownerSearch").val('');
      $("#ownerSearch").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if (type == 'lead_owner') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  async getTreatment() {
    await this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
        this.treatments_copy = this.treatments;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  getTlsCms() {
    this.userapi.getTlsCms().subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  getLabLeadDetails() {
    let data = this.dialogData;
    this.dataLoaded = false;
    this.labapi.getLabLeadDetails(data).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        if (data.data) {
          this.moveLeadForm.controls['name'].setValue(data.data.lead_name);
          this.moveLeadForm.controls['mobile'].setValue(data.data.mobile);
          this.moveLeadForm.controls['city_id'].setValue(data.data.city_id);
          this.moveLeadForm.controls['circle_id'].setValue(data.data.circle_id);
          this.moveLeadForm.controls['description'].setValue(data.data.description);
          this.moveLeadForm.controls['gender'].setValue(data.data.gender);
        }
      } else {
        if (data.error_type != 'no')
          this.sharedapi.presentToast('Error Occured');
      }
    },
      error => {
        this.sharedapi.checkError(error);
      });
  }


  async submitLead() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.moveLeadForm.invalid) {
      this.loading = false;
      return;
    }
    await this.labapi.addMoveLeadToLead(this.moveLeadForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.dialogRef.close();
          this.sharedapi.presentToast('Lead has been Added successfully.');
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
  }


}
